App.factory('questionFactory', questionFactory);

questionFactory.$inject = [
    'DispatcherService'
];

function questionFactory(DispatcherService) {
    return {
        update: function(questionId, data) {
            return DispatcherService.put('questions/' + questionId, data);
        }
    };
}
